import {fetchAPI, generateUrl} from "api";
import {handleResponse} from "helpers/Requests";
import {deserializeTaskCount, TaskCount} from "../../../models/task/Count";

const showTaskCount = () => {
  const url = generateUrl("/web/v1/tasks/counts");

  return fetchAPI(url)
    .then(handleResponse<TaskCount>(deserializeTaskCount));
};

export {
  showTaskCount
};
